export default __webpack_public_path__ + "static/media/Beard_1_C1.ef62e01e.svg";